// extracted by mini-css-extract-plugin
module.exports = {"block":"ListedSince_block__2YUGB"};